import React from 'react';
import Paper from '@mui/material/Paper';
import {Typography} from '@customink/pigment-react';
import {CampaignQuery} from '../../models/orderConfirmation';
import './OrderConfirmationCard.scss';

type OrderSummaryKey = keyof CampaignQuery;

const ORDER_SUMMARY_ITEM_KEYS = [
  'totalItemsQuantity',
  'subtotal',
  'shipping',
  'tax',
  'totalCollectedOnline'
];

const ORDER_SUMMARY_ITEM_LABELS = [
  'Number of Items',
  'Subtotal',
  'Shipping & Handling',
  'Tax',
  'Order Total'
];

const OrderSummaryCard: React.FC<CampaignQuery> = ({
  ...campaign
}: CampaignQuery) => {
  return (
    <Paper elevation={0} square className="summary">
      <div className="summary-inner">
        <Typography variant="h6" className="summary-title">
          <strong>Order Summary</strong>
        </Typography>
        {ORDER_SUMMARY_ITEM_KEYS.map((key: OrderSummaryKey, index) => {
          let lastLine = false;
          if (index === Object.keys(campaign).length - 1) {
            lastLine = true;
          }
          const value = campaign[key] as number;

          return (
            <Typography
              key={key}
              variant={`${lastLine ? 'h6' : 'bodyLong2'}`}
              className={`summary-item${lastLine ? '-divider' : ``}`}>
              {ORDER_SUMMARY_ITEM_LABELS[index]}:
              <span>
                {key.includes('Item') ? campaign[key] : `$${value.toFixed(2)}`}
              </span>
            </Typography>
          );
        })}
        <Typography className="paidVia" variant="bodyLong2">
          Paid via Credit Card
        </Typography>
      </div>
    </Paper>
  );
};

export default OrderSummaryCard;
